import { useEffect, useState, useCallback, useContext } from "react";
import { ThemeContext } from "./themeContext";
import lightTheme from "./lightTheme";
import darkTheme from "./darkTheme";
import { ThemeProvider } from "@mui/material";

export const THEME = {
    LIGHT: "light",
    DARK: "dark"
}

const THEME_KEY = "theme";

export function CustomThemeProvider({children}){
    const [themeMode, setThemeMode] = useState(THEME.LIGHT);

    useEffect(() => {
        const savedTheme = localStorage.getItem(THEME_KEY);

        if(savedTheme){
            setThemeMode(savedTheme);
        }
        else{
            localStorage.setItem(THEME_KEY, THEME.LIGHT);
            setThemeMode(THEME.LIGHT);
        }
    }, []);

    const toggleTheme = useCallback(() => {
        const newThemeMode = themeMode === THEME.LIGHT ? THEME.DARK : THEME.LIGHT;

        setThemeMode(newThemeMode);
        localStorage.setItem(THEME_KEY, newThemeMode);
    }, [themeMode]);

    const getActiveTheme = useCallback(() => {
        return themeMode === THEME.LIGHT ? lightTheme : darkTheme;
    }, [themeMode, lightTheme, darkTheme]);

    const getInverseTheme = useCallback(() => {
        return themeMode === THEME.LIGHT ? darkTheme : lightTheme;
    }, [themeMode, lightTheme, darkTheme]);

    const value = {
        themeMode,
        getActiveTheme,
        toggleTheme,
        getInverseTheme
    }

    return (
        <ThemeContext.Provider value={value}>
            <ThemeProvider theme={getActiveTheme()}>
                {children}
            </ThemeProvider>
        </ThemeContext.Provider>
    );
}

export const GetTheme = () => {
    return useContext(ThemeContext);
};